var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M33.6,4.4l-4.2-4.2C29.2,0.1,29.1,0,28.9,0c-0.2,0-0.4,0.1-0.5,0.2L10.7,17.9c-0.1,0.1-0.3,0.2-0.5,0.2\n\tS9.8,18,9.6,17.9l-4.2-4.2c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2l-4.2,4.2c-0.3,0.3-0.3,0.8,0,1.1l9.4,9.4\n\tc0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2L33.6,5.5C33.8,5.2,33.8,4.7,33.6,4.4z","key":1})]);
}

TickInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 33.8 28.6","style":{"enableBackground":"new 0 0 33.8 28.6"},"xmlSpace":"preserve"};

module.exports = TickInline;

TickInline.default = TickInline;
